import Ajax from '@/api/ajax'

// 获取导航
export const getNavList = (data) => Ajax.request('/navigation/list', 'post', data, {showLoading: true})

// 获取合作伙伴列表
export const getPartnerList = (data) => Ajax.request('/partner/list', 'post', data, {showLoading: true})

// 添加联系方式
export const contactCreate = (data) => Ajax.request('/contact/request/create', 'post', data, {showLoading: true})

// 获取导航内容列表
export const navContentList = (data) => Ajax.request('/navigation/content/list', 'post', data, {showLoading: true})

// 获取导航详情
export const navDetail = (data) => Ajax.request('/navigation/detail', 'get', data, {showLoading: true})

//获取富文本详情
export const richDetail = (data) => Ajax.request('/richText/detail', 'post', data, {showLoading: true})

//获取contentDetail
export const navContentDetail = (data) => Ajax.request('/navigation/content/detail', 'get', data, {showLoading: true})

// 查询官网footer显示信息
export const contactFooter = (data) => Ajax.request('/contact/selectOne', 'get', data, {showLoading: true})